






















import {Component, Prop} from "vue-property-decorator"
import AbpBase from "../../../../lib/abpbase"
import {GetMaterialsSynStatusById,SynMaterialsToTenants,SynManufacturerToTenants} from "@/api/material"
@Component({
    components: {}
})
export default class Syn extends AbpBase {
    @Prop({type: Boolean, default: false}) value: boolean
    @Prop({type: Object, default: {}}) data: any
    @Prop({type: Number, default: 1}) dataType: any
    created() {
        this.getData()
    }
    async getData(){
        this.table.loading = true
        let res = await GetMaterialsSynStatusById({
            id:this.data.id,
            dataType:this.dataType,
        })
        this.list = res.data
        this.table.loading = false
    }
    tenantIds = []
    list = []
    selection = []
    columns = [
        {
            title:'中心',
            key:'tenantName',
        },
        {
            title:'是否已同步',
            key:'status',
            render: (h: any, p: any) => {
                return h('el-tag', {
                    props: {
                        type: p.row.status ? 'success' : 'danger',
                    },
                }, p.row.status ? '已同步' : '未同步' )
            }
        },
        {
            title:'操作',
            width:80,
            render:(h:any,p:any)=> {
                return h('el-button', {
                    props: {
                        type: 'text',
                        size: 'small'
                    },
                    directives:[{
                        name:'allow'
                    }],
                    on: {
                        click: () => {
                            this.synItem(p.row)
                        }
                    }
                }, '同步')
            },
        }
    ]
    synItem(row:any){
        this.syn([row.tenantId])
    }
    synAll(){
        if(this.selection.length===0){
            this.$message.warning('请选择中心')
            return false
        }
        this.syn(this.selection.map(item=>{return item.tenantId}))
    }
    async syn(tenantIds:any){
        let res;
        if(this.dataType === 1){
            res = await SynMaterialsToTenants({id:this.data.id, tenantIds:tenantIds})
        }else{
            res = await SynManufacturerToTenants({id:this.data.id, tenantIds:tenantIds})
        }
        if (res.code === 2000) {
            this.getData()
        }
    }
    cancel() {
        this.$emit('input', false);
    }
}
